module.exports = __webpack_public_path__ + "static/media/share-link-mobile.0d1c317f.svg";